import styled from 'styled-components';
import {
  flexBoxCenter,
  justifyContentSpaceBetween,
  layerA,
  layerA90Deg,
} from 'shared/styles/commonStyles';
import DisplayBox from './DisplayBox';
import { useSelector } from 'react-redux';
import { selectUnits } from 'shared/slice/unitsSlice';
import { selectEssSwitch } from 'shared/slice/essSwitchSlice';
import { selectTgsSwitch } from 'shared/slice/tgsSwitchSlice';
import { selectTesSwitch } from 'shared/slice/tesSwitchSlice';
import { useSetAndCurrentTemp } from 'shared/hooks';

const MCDisplayBoxWrapper = ({
  swtName,
  location,
  machine,
}) => {
  const unitsStatus = useSelector(selectUnits);
  const { isF } = unitsStatus;
  const { flatEssSwitch,flatTgsSwitch,flatTesSwitch } = useSelector(
    swtName === 'ess'
      ? selectEssSwitch
      : swtName === 'tgs'
      ? selectTgsSwitch
      : selectTesSwitch
  );

  const swtStatus =
    swtName === 'ess' ? flatEssSwitch : swtName === 'tgs' ? flatTgsSwitch : flatTesSwitch;
  const switchStatus = swtStatus[location][machine];
  const { setTemp, currentTemp } = useSetAndCurrentTemp(switchStatus);

  return (
    <Wrapper>
      <InnerWrapper>
        <DisplayBox
          title='set temperature'
          data={setTemp}
          unit={isF ? '°F' : '°C'}
        />
        <DisplayBox
          title='current temperature'
          data={currentTemp}
          unit={isF ? '°F' : '°C'}
        />
      </InnerWrapper>
    </Wrapper>
  );
};

export default MCDisplayBoxWrapper;

const Wrapper = styled.div`
  width: 397px;
  height: 64px;
  border-radius: 6px;
  ${flexBoxCenter};
  ${layerA90Deg};
`;
const InnerWrapper = styled.div`
  width: 389px;
  height: 54px;
  border-radius: 8px;

  ${layerA}
  ${justifyContentSpaceBetween}

  padding: 0 2px;
`;
